import React, { useRef, useState } from 'react';
import { selectedTxnAmount } from '../../utils/functions/invoiceAmounts';
import { Button } from '@mui/material';
import Swal from 'sweetalert2';
import SearchApprovedAndTableData from './SearchApprovedAndTableData';
import SearchBankAndTableMatch from './SearchBankAndTableMatch';
import api from '../../utils/functions/api';
import jwtDecode from 'jwt-decode';
import { getStorage } from '../../utils/functions/localstorage';
import axios from '../../utils/functions/api';
import { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Loading from '../../components/Loading';
import { useAppovedDataQuery } from '../../services/AppovedData';
import { useTranslation } from 'react-i18next';
import { invoiceDraftKey, mergePendingInvoiceDrafts, savedInvoiceFields } from '../../utils/functions/invoiceDrafts';

function MatchingMain() {
  const pendingInvoiceDrafts = useRef(new Map());
  const { t } = useTranslation();
  const [invoicesDataApproved, setInvoicesDataApproved] = useState([]);
  const [invoicesDataBank, setInvoicesDataBank] = useState([]);
  const token = getStorage('token');
  const decoded = jwtDecode(token);
  const [dataApproved, setDataApproved] = useState([]);
  const [total, setTotal] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchText, setSearchText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [searchUpload, setSearchUpload] = useState('');
  const [isFetchingBank, setIsFetchingBank] = useState(false);
  const [bankRefreshKey, setBankRefreshKey] = useState(0);
  const [page, setPage] = useState(0);
  const [clearSelectedItems, setClearSelectedItems] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [approvedSortBy, setApprovedSortBy] = useState('upload_ref');
  const [approvedSortOrder, setApprovedSortOrder] = useState('desc');

  const calculateTotalAmount = () => selectedTxnAmount(selectedItems);

  const handleApprovedSort = (field) => {
    setPage(0);
    setApprovedSortOrder((prevOrder) =>
      approvedSortBy === field
        ? prevOrder === 'asc'
          ? 'desc'
          : 'asc'
        : 'asc',
    );
    setApprovedSortBy(field);
  };

  const {
    data: dataApi,
    isFetching,
    refetch,
  } = useAppovedDataQuery(
    {
      page: page === 0 ? 1 : page + 1,
      size: rowsPerPage,
      search: searchText || '',
      searchUploadRef: searchUpload || '',
      sortBy: approvedSortBy,
      sortOrder: approvedSortOrder,
    },
    {
      refetchOnMountOrArgChange: true,
    },
  );

  useEffect(() => {
    setDataApproved(mergePendingInvoiceDrafts(dataApi?.data, pendingInvoiceDrafts.current));

    if (dataApi) {
      const { pagination } = dataApi;

      setTotal(pagination.total);
    }
  }, [dataApi]);

  // const fetchApprovedData = async () => {

  //   try {
  //     const response = await axios.get(
  //       `${
  //         process.env.REACT_APP_API_URL_admin
  //       }/matchstatement/get-approved-data?page=${
  //         page + 1
  //       }&size=${rowsPerPage}&testParamText=${searchText}&testParamUpload=${searchUpload}`,
  //     );
  //     const data = response?.data;
  //     setDataApproved(data?.data);
  //     setTotal(response?.data?.pagination?.total);
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   } finally {
  //     setIsFetching(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchApprovedData();
  // }, [page, rowsPerPage]);

  const Matching = async () => {
    setIsLoading(true);
    try {
      const latestSelectedInvoices = selectedItems.map((selected) => {
        return (
          dataApproved.find(
            (row) =>
              row.invoice_no === selected.invoice_no &&
              row.transaction_id === selected.transaction_id,
          ) || selected
        );
      });

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL_admin}/matchstatement/match-invoice`,
        {
          invoices: latestSelectedInvoices.length
            ? latestSelectedInvoices
            : invoicesDataApproved,
          statement: invoicesDataBank,
          matchBy: decoded.NAME,
        },
      );

      const resData = response.data;

      const errorItems = resData.result?.filter((item) => {
        const isOuterError = item.status === 'error';

        const innerStatusCode = item.data?.result?.status_code;
        const isInnerError = innerStatusCode && innerStatusCode !== 200;

        return isOuterError || isInnerError;
      });

      if (errorItems && errorItems.length > 0) {
        const errorMessages = errorItems
          .map((item) => {
            const msg =
              item.message || item.data?.result?.message || 'Unknown Error';
            return `• ${item.invoice_no}: ${msg}`;
          })
          .join('<br/>');

        setClearSelectedItems(true);
        Swal.fire({
          icon: 'error',
          title: 'เกิดข้อผิดพลาดในการ Matching',
          html: errorMessages,
          confirmButtonText: 'ตกลง',
          didOpen: () => {
            document.querySelector('.swal2-container').style.zIndex = '99999';
          },
        });
      } else {
        // 2. ถ้าไม่มี Error เลย ให้เช็คว่ามีรายการที่ไม่ใช่ Success หรือไม่ (เช่น skipped)
        const nonWarningStatuses = ['success', 'recovered', 'already_matched_local'];
        const warningItems = resData.result?.filter(
          (item) => !nonWarningStatuses.includes(item.status),
        );

        if (warningItems && warningItems.length > 0) {
          // กรณีมีรายการที่ Skipped หรือ Warning (เหลือง)
          const warningMessages = warningItems
            .map(
              (item) =>
                `• ${item.invoice_no}: ${item.message} (${item.status})`,
            )
            .join('<br/>');

          setClearSelectedItems(true);
          Swal.fire({
            icon: 'warning',
            title: 'ดำเนินการไม่สมบูรณ์',
            html: warningMessages,
            confirmButtonText: 'ตกลง',
            didOpen: () => {
              document.querySelector('.swal2-container').style.zIndex = '99999';
            },
          });
        } else {
          // 3. กรณี Success ทั้งหมด (เขียว)
          setInvoicesDataApproved([]);
          setClearSelectedItems(true);

          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Matching เสร็จสิ้น',
            showConfirmButton: false,
            timer: 3000,
            didOpen: () => {
              document.querySelector('.swal2-container').style.zIndex = '99999';
            },
          });
        }
      }
    } catch (error) {
      console.error('Error :', error);
      const errorMessage = error?.response?.data?.error?.message;

      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: errorMessage || 'ไม่สามารถทำรายการได้ในขณะนี้',
        confirmButtonText: 'ตกลง',
        didOpen: () => {
          document.querySelector('.swal2-container').style.zIndex = '99999';
        },
      });
    } finally {
      setIsLoading(false);
      setInvoicesDataBank([]);
      setBankRefreshKey((key) => key + 1);
      await refetch();
    }
  };

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-5">
      <div>{t('app.matchingStatement')}</div>
      <Loading isLoading={isLoading} />
      <div className="w-full">
        <SearchApprovedAndTableData
          t={t}
          clearSelectedItems={clearSelectedItems}
          setClearSelectedItems={setClearSelectedItems}
          isFetching={isFetching}
          invoicesDataApproved={invoicesDataApproved}
          setInvoicesDataApproved={setInvoicesDataApproved}
          matchButtonApi={Matching}
          dataApproved={dataApproved}
          setDataApproved={setDataApproved}
          total={total}
          setTotal={setTotal}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          // handleOnClick={handleSearchAppoved}
          setSearchText={setSearchText}
          searchText={searchText}
          searchUpload={searchUpload}
          setSearchUpload={setSearchUpload}
          setSelectedItems={setSelectedItems}
          selectedItems={selectedItems}
          calculateTotalAmount={calculateTotalAmount}
          approvedSortBy={approvedSortBy}
          approvedSortOrder={approvedSortOrder}
          onApprovedSort={handleApprovedSort}
          onDraftSaved={async (savedInvoice) => {
            pendingInvoiceDrafts.current.set(invoiceDraftKey(savedInvoice), savedInvoiceFields(savedInvoice));
            const refreshed = await refetch();
            // Keep the successfully saved fields if the refreshed list is stale.
            setDataApproved((current) => mergePendingInvoiceDrafts(
              refreshed.data?.data || current || [], pendingInvoiceDrafts.current,
            ));
          }}
        />
      </div>
      <div className="w-full">
        <SearchBankAndTableMatch
          refreshKey={bankRefreshKey}
          t={t}
          setIsFetchingBank={setIsFetchingBank}
          isFetchingBank={isFetchingBank}
          invoicesDataBank={invoicesDataBank}
          setInvoicesDataBank={setInvoicesDataBank}
          matchButtonApi={Matching}
          calculateTotalAmount={calculateTotalAmount}
        />
      </div>
    </div>
  );
}

export default MatchingMain;
